module.exports = __webpack_public_path__ + "img/img_18.2b275c41.svg";